import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
    const location = useLocation();
    const isHome = location.pathname === '/';

    const handleLinkClick = (e, id) => {
        if (isHome && id) {
            e.preventDefault();
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section id="hero" className="hero-dark">
            <div className="hero-bg-image"></div>
            <div className="hero-overlay"></div>
            
            {/* Dramatic Light Rays & Glows */}
            <div className="hero-glow hero-glow-left"></div>
            <div className="hero-glow hero-glow-right"></div>
            <div className="hero-glow hero-glow-center"></div>
            <div className="hero-ray hero-ray-left"></div>
            <div className="hero-ray hero-ray-right"></div>

            <div className="hero-content">
                <motion.div
                    className="hero-badge-container"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2, duration: 0.8 }}
                >
                    <span className="hero-badge frost">
                        <span className="hero-badge-dot" />
                        Available for New Projects
                    </span>
                </motion.div>

                <motion.h1
                    className="hero-title-massive"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.8 }}
                >
                    Building Digital Solutions<br />
                    <span className="text-gradient">That Drive Growth.</span>
                </motion.h1>

                <motion.p
                    className="hero-description-premium"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6, duration: 0.8 }}
                >
                    We design and engineer modern digital solutions that help businesses and organizations operate smarter, connect with their customers, and scale with confidence.
                </motion.p>

                <motion.div
                    className="hero-actions"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.8, duration: 0.8 }}
                >
                    <Link to="/contact" className="btn-primary glow-hover">
                        Start a Project
                    </Link>
                    <Link to="/" onClick={(e) => handleLinkClick(e, 'solutions')} className="btn-secondary frost">
                        Explore Our Solutions
                    </Link>
                </motion.div>

                <motion.div 
                    className="hero-tech-stack"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 0.8 }}
                >
                    <p>Web & Mobile &bull; Software Engineering &bull; Cloud &bull; AI &amp; Automation &bull; Systems Integration</p>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
